import { getCurrentUserEmail } from '../auth';

const toIsoOrNull = (date) => {
  if (!date) return null;
  try {
    const d = date instanceof Date ? date : new Date(date);
    return isNaN(d.getTime()) ? null : d.toISOString();
  } catch {
    return null;
  }
};

export const buildReportPayload = ({
  userId = getCurrentUserEmail(),
  type = '',
  reportNo = '',
  problemStatement = '',
  startDate = null,
  endDate = null,
  partNo = '',
  supplierName = '',
  role = '',
  division = '',
  pageSize = 100,
  pageNumber = 0,
  originatorEmailID = '',
  coordinatorEmailID = '',
  responsibleEmailID = '',
  isOverdue = false,
}) => {
  return {
    userId: userId || '',
    type: type || '',
    reportNo: reportNo || '',
    problemStatement: problemStatement || '',
    startDate: toIsoOrNull(startDate),
    endDate: toIsoOrNull(endDate),
    partNo: partNo || '',
    supplierName: supplierName || '',
    role: role || '',
    division: division || '',
    pageSize: pageSize || 100,
    pageNumber: pageNumber || 1,
    originatorEmailID: originatorEmailID || '',
    coordinatorEmailID: coordinatorEmailID || '',
    responsibleEmailID: responsibleEmailID || '',
    isOverdue: Boolean(isOverdue)
  };
};
